import { useI18n } from "@/api/i18n";
import { CompanyLayoutMainContentContainer } from "@/components/layout/CompanyLayout";
import { Container } from "@/components/shared/Container";
import { MetaTitleWithSeparator } from "@/domains/business/seo";

export default function CompanySearchFreelancerCreateJobOfferRoute() {
  const { t } = useI18n();

  return (
    <>
      <MetaTitleWithSeparator>
        {t("company.search.freelancers.create_job_offer.title")}
      </MetaTitleWithSeparator>

      <CompanyLayoutMainContentContainer>
        <Container size="full" class="mb-6 w-full">
          <h1 class="text-3xl font-bold text-gray-900 mb-2">
            {t("company.search.freelancers.create_job_offer.title")}
          </h1>
        </Container>
      </CompanyLayoutMainContentContainer>
    </>
  );
}
